import { API, Auth, graphqlOperation } from "aws-amplify";
import { Job } from "../../../shared/model/Job";
import { createJob, updateJob } from "../graphql/mutations";
import { getJob, searchJobs } from "../graphql/queries";

export const executeUpdateJob = async (job: Job, createNew: boolean) => {
    let operation = updateJob;
    if (createNew) {
        operation = createJob;
    }
    const response: any = await API.graphql(
        graphqlOperation(operation, {
            input: job
        }),
    );

    return response;
}

export const executeFetchJob = async () => {
    const user = await Auth.currentAuthenticatedUser();
    const job: any = await API.graphql(
        graphqlOperation(getJob, { owner: user.username }),
    );

    return job;
}

export const executeFetchJobs = async (variables: any) => {
    const response: any = await API.graphql({
        query: searchJobs,
        variables: variables,
        authMode: 'API_KEY'
    });
    let jobs: Job[] = response.data.searchJobs?.items;
    jobs = jobs
        .filter(job => job.expiresAt != null && job.expiresAt?.length > 0 && new Date(job.expiresAt) > new Date())
        .sort((a, b) => {
            if (a?.isHighlight && !b?.isHighlight) return -1;
            if (a?.createdAt && b?.createdAt) return a.createdAt > b.createdAt ? -1 : 1;
            else return -1
        })
    return jobs;
}